module.exports = __webpack_public_path__ + "static/how_it_works_fun_art-bf43360bdc942224b867cdeabf458103.png";